import { render, staticRenderFns } from "./TerminalsList.vue?vue&type=template&id=1ef01222&"
import script from "./TerminalsList.vue?vue&type=script&lang=js&"
export * from "./TerminalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TerminalsList.vue"
export default component.exports